import React from 'react';
const SvgFilePdf: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g strokeLinecap="round" strokeLinejoin="round">
        <path d="M18.414 6.414l-2.828-2.828A2 2 0 0014.172 3H7a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V7.828a2 2 0 00-.586-1.414z" />
        <path d="M19 8h-4a1 1 0 01-1-1V3M10.34 16.55h3.32M10.833 12.751v-1.168c0-.322.261-.583.583-.583h1.168c.322 0 .583.261.583.583v1.168a.583.583 0 01-.583.583h-1.168a.584.584 0 01-.583-.583zM8 17.417v-1.168c0-.322.261-.583.583-.583h1.168c.322 0 .583.261.583.583v1.168a.583.583 0 01-.583.583H8.583A.583.583 0 018 17.417zM13.667 17.417v-1.168c0-.322.261-.583.583-.583h1.168c.322 0 .583.261.583.583v1.168a.584.584 0 01-.584.583h-1.168a.583.583 0 01-.582-.583zM14.24 15.67l-1.51-2.36M9.76 15.67l1.51-2.36" />
      </g>
    </svg>
  );
};
export default SvgFilePdf;
